export const constants = {
    // mainBreakpoint: window.matchMedia("only screen and (max-width: 1152px)"),
    isDevice: false,
    isMobile: false
}
export const instances = {
    cc: undefined,
    mainmenu: undefined,
    navscroller: undefined,
    lightbox: undefined,
    cutofftext: undefined
}
